import React from 'react';
interface EyebrowProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
}
export function Eyebrow({
  children,
  tone = 'light',
  className = ''
}: EyebrowProps) {
  const toneClasses = tone === 'light' ? 'border-line text-ink-muted' : 'border-white/20 text-ink-light/80';
  return <span className={`inline-block rounded-full border px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] ${toneClasses} ${className}`} data-id="element-25" data-mp="1gt4nr3tcce23">
      {children}
    </span>;
}